<template>
  <div class="studylist">
    <topcon :maxtitle="maxtitle" :mintitle="mintitle" :sign="signtype"></topcon>

    <div class="alllist">
      <div class="signle" v-for="(item,index) in list" :key="index"
           @click="todetail(item)">
        <div class="title">
          {{ item.title ? item.title.substring(0, 22) : '' }}
          <span v-if="item.title.length>22">...</span>
        </div>
        <div class="download" @click="downloadFile(item)">立即下载</div>
      </div>
    </div>

  </div>

</template>

<script>

import topcon from "../com/topcon.vue";

export default {
  components: {
    topcon,
  },
  props: ['sign'],
  data: function () {
    return {
      maxtitle: '政策',
      mintitle: '文件',
      list: [],
      signtype: '',
      pageNo: 1,
      pageSize: 8,
    };
  },

  mounted() {
    let params = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
    }
    this.signtype = this.sign + ''
    // this.getDatalist()
    if (this.sign == 4) {
      this.maxtitle = '政策'
      this.mintitle = '文件'
      params.regionType = 0
    } else if (this.sign == 5) {
      this.maxtitle = '优秀'
      this.mintitle = '案例/课件'
      params.regionType = 1

    } else if (this.sign == 6) {
      this.maxtitle = '证书'
      this.mintitle = '模板'
      params.regionType = 2

    } else if (this.sign == 7) {
      this.maxtitle = '音/视频'
      this.mintitle = '资料'
      params.regionType = 3
    }
    this.getDatalist(params)

  },

  methods: {
    downloadFile(item) {
      window.open(this.$fileAccessHttpUrl(item.fileId_dictText))
    },
    getDatalist(params) {
      this.$get('/web/download/list', params).then(res => {
        if (res.success) {
          this.list = res.result.records
        }
      })
    },

    todetail(item) {
      // this.$router.push({ path: '/learnmaterials?id='+item.id +'&type='+item.studyType});
    }

  },


};
</script>

<style scoped=" scoped" lang="scss">

.studylist {

  .alllist {
    margin-top: 30px;
    min-height: 320px;

    .signle {
      display: flex;
      align-items: center;
      height: 40px;
      

      .title {
        flex: 1;
        font-size: 18px;
        font-weight: 400;
        color: #000000;
        margin-left: 10px;
      }

      .download {
        width: 120px;
        text-align: right;
        font-size: 18px;
        font-weight: 400;
        color: #E61F26;
        cursor: pointer;
      }
    }

    .signle:hover .title {
      color: #E61F26;
    }

  }


}

</style>
